import {
  dwColor,
  dwControlHeight,
  dwFont,
  dwLayout,
  dwMotion,
  dwOverlay,
  dwRadius,
  dwShadow,
  dwSpace,
  dwType,
} from './tokens';

// inkStrong → ink-strong, ink2 → ink-2
const kebab = (name: string) => name.replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();

/**
 * Zmienne CSS `--dw-*` z tokenów, dla modułów SCSS (`color: var(--dw-color-ink-2)`).
 * Liczone z `tokens.ts`, więc SCSS i motyw antd nie mogą się rozjechać.
 */
export function dwCssVariables(): Record<string, string> {
  const vars: Record<string, string> = {};

  Object.entries(dwColor).forEach(([name, value]) => {
    vars[`--dw-color-${kebab(name)}`] = value;
  });
  vars['--dw-color-overlay'] = dwOverlay;
  vars['--dw-font-sans'] = dwFont.sans;
  vars['--dw-font-mono'] = dwFont.mono;
  Object.entries(dwType).forEach(([role, { size, line, weight }]) => {
    const key = kebab(role);
    vars[`--dw-text-${key}-size`] = `${size}px`;
    vars[`--dw-text-${key}-line`] = `${line}px`;
    vars[`--dw-text-${key}-weight`] = String(weight);
  });
  dwSpace.forEach((value) => {
    vars[`--dw-space-${value}`] = `${value}px`;
  });
  Object.entries(dwRadius).forEach(([name, value]) => {
    vars[`--dw-radius-${kebab(name)}`] = `${value}px`;
  });
  Object.entries(dwControlHeight).forEach(([name, value]) => {
    vars[`--dw-control-${name}`] = `${value}px`;
  });
  Object.entries(dwLayout).forEach(([name, value]) => {
    vars[`--dw-layout-${kebab(name)}`] = `${value}px`;
  });
  Object.entries(dwShadow).forEach(([name, value]) => {
    vars[`--dw-shadow-${kebab(name)}`] = value;
  });
  vars['--dw-motion-fast'] = `${dwMotion.fast}ms`;
  vars['--dw-motion-base'] = `${dwMotion.base}ms`;
  vars['--dw-motion-ease'] = dwMotion.ease;

  return vars;
}

/** Ustawia zmienne na `<html>` przed pierwszym renderem, żeby nie było mignięcia bez stylów. */
export function applyDwCssVariables(root: HTMLElement): void {
  Object.entries(dwCssVariables()).forEach(([name, value]) => {
    root.style.setProperty(name, value);
  });
}
